import { useEffect, useState } from "react";
import { Search } from "lucide-react";
import AdminSidebar from "../AdminSidebar";
import "../../../styles/styles.css";
import AdminHeader from "../AdminHeader";
import GenerateDoc from "./GenerateDoc";
import AllDocs from "./AllDocs";

const AdminAgreementDashboard = () => {
  const [activeTab, setActiveTab] = useState("alldocs");
  const [searchQuery, setSearchQuery] = useState("");
  const [refreshKey, setRefreshKey] = useState(0); // State to trigger re-render

  useEffect(() => {
    const interval = setInterval(() => {
      setRefreshKey((prevKey) => prevKey + 1); // Increment the key to trigger re-render
    }, 500000); // Fetch every 5 minutes

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);
  const renderContent = () => {
    switch (activeTab) {
      case "generatedocs":
        return <GenerateDoc searchQuery={searchQuery} />;
      case "alldocs":
        return <AllDocs searchQuery={searchQuery} />;

      default:
        return <GenerateDoc searchQuery={searchQuery} />;
    }
  };

  return (
    <>
      <AdminHeader page="dashboard" />
      <AdminSidebar />
      <div className="dashboard">
        <h1>Bitstek Advisory Agreements</h1>
        <div className="tabs">
          <button
            className={activeTab === "generatedocs" ? "active" : ""}
            onClick={() => setActiveTab("generatedocs")}>
            Generate Document
          </button>
          <button
            className={activeTab === "alldocs" ? "active" : ""}
            onClick={() => setActiveTab("alldocs")}>
            All Documents
          </button>
        </div>

        {/* Search Bar with Icon */}
        <div className="search-bar">
          <Search className="search-icon" size={20} />
          <input
            type="text"
            placeholder="Search"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>

        <div className="content">{renderContent()}</div>
      </div>
    </>
  );
};

export default AdminAgreementDashboard;
